import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Input, Col, Select} from 'antd'
import FormModal from './FormModal'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'

@inject('permissionManagementStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {permissionManagementStore} = this.props
    permissionManagementStore.onChangePermissionList([])
    permissionManagementStore.onChangePageNo()
    permissionManagementStore.onSearchAction({
      name: '',
      key: '',
    }, 1, PAGE_SIZE_DEFAULT)
  }

  handleSearch = () => {
    const {permissionManagementStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        name: fieldsValue.name,
        key: fieldsValue.key
      }
      permissionManagementStore.onChangePageNo()
      permissionManagementStore.onSearchAction(params, 1, PAGE_SIZE_DEFAULT)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }
  onChange = (value) => {
    const {permissionManagementStore} = this.props
    const {searchItem} = permissionManagementStore
    permissionManagementStore.onChangePermissionType(value)
    permissionManagementStore.onChangePageNo()
    permissionManagementStore.onSearchAction(searchItem, 1, PAGE_SIZE_DEFAULT)
  }

  render() {
    const {permissionManagementStore, location, t} = this.props
    const {permissionType} = permissionManagementStore
    return (
      <div className="container">
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 0]}>
            <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
              <Form.Item name="type" label={t(`permissionManagement.permissionType`)}>
                <Select placeholder={t(`general.pleaseEnter`)} onChange={this.onChange}>
                  {/*<Select.Option key='OPERATION' value='OPERATION'>OPERATION</Select.Option>*/}
                  {/*<Select.Option key='API' value='API'>API</Select.Option>*/}
                  <Select.Option key="MENU" value="MENU">MENU</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {permissionType === 'OPERATION' ?
              <>
                <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                  <Form.Item name="name" label={t(`permissionManagement.permissionName`)}
                             rules={[{
                               message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.permissionName`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }]}>
                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                  <Form.Item name="key" label={t(`permissionManagement.permissionKey`)}
                             rules={[{
                               message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.permissionKey`)} ${t(`general.withoutSpecialChats`)}`,
                               pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                             }]}>
                    <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
                  </Form.Item>
                </Col>
              </> : permissionType === 'API' ?
                <>
                  <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                    <Form.Item name="name" label={t(`permissionManagement.apiName`)}
                               rules={[{
                                 message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.apiName`)} ${t(`general.withoutSpecialChats`)}`,
                                 pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                               }]}>
                      <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                    <Form.Item name="key" label={t(`permissionManagement.apiKey`)}
                               rules={[{
                                 message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.apiKey`)} ${t(`general.withoutSpecialChats`)}`,
                                 pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                               }]}>
                      <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
                    </Form.Item>
                  </Col>
                </> :
                <>
                  <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                    <Form.Item name="name" label={t(`permissionManagement.menuName`)}
                               rules={[{
                                 message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.menuName`)} ${t(`general.withoutSpecialChats`)}`,
                                 pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                               }]}>
                      <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={4} xxl={4} span={4}>
                    <Form.Item name="key" label={t(`permissionManagement.menuKey`)}
                               rules={[{
                                 message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.menuKey`)} ${t(`general.withoutSpecialChats`)}`,
                                 pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                               }]}>
                      <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
                    </Form.Item>
                  </Col>
                </>
            }
            <Col span={8} offset={4} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </div>
    )
  }
}

export default withTranslation()(SearchForm)
